export default __webpack_public_path__ + "static/media/union-plus.add9c0e7.svg";